//  * @package         src/components/Editresponse
//  * @author          Parimal A Ghadiyali
//  * @date            16 June 2022
//  * @type            Editresponse middle Content Component File
//  * @description -   This file renders the html and functionality for center component when questions tab is choosed.
<template>
  <!--
  All in one question - all questions are on same page
  *********************************************************
  *********************************************************
  *********************************************************
  -->
  <div class="content preview_content">
    <v-wait for="adding response">
      <template slot="waiting">
        <div id="loadingDiv" class="loadingDiv_analytics">
          <div class="loadersec">
            <div class="loader"></div>
          </div>
      </div>
      </template>
    </v-wait>
    <div style="margin-left: 4%;">
        <table>
          <tr>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333; padding: 3px;">Date</td>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333; padding: 3px;">:</td>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333;padding-left: 3px;">{{this.surveyResponseDateDetails.dt_date_collected}}</td>
          </tr>
          <tr>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333; padding: 3px;">Date Sent</td>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333; padding: 3px;">:</td>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333;padding-left: 3px;">{{this.surveyResponseDateDetails.dt_date_sent}}</td>
          </tr>
          <tr>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333; padding: 3px;">Date Received</td>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333; padding: 3px;">:</td>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333;padding-left: 3px;">{{this.surveyResponseDateDetails.dt_added_at}}</td>
          </tr>
          <tr>
            <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333; padding: 3px;">GPS Location</td>
            <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333; padding: 3px;">:</td>
            <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333;padding-left: 3px;">{{this.surveyResponseDateDetails.gps_location}}</td>
          </tr>
          <tr>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333; padding: 3px;">User</td>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333; padding: 3px;">:</td>
              <td class="info-td" style="font-size: 13px; font-weight: 500; color: #333333;padding-left: 3px;">{{this.surveyResponseDateDetails.st_user_name}}</td>
          </tr>
        </table>
    </div>
    <form @submit.prevent="validateBeforeSubmit" novalidate class="formEditResponse" autocomplete="off">
      <div class="service-provide-info"> 
        <div v-for="(controlData, index) in surveyQuestionDetailsData" :key="index">

          <transition name="fade">
            <div>
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': (errors.has('map_'+controlData.queDetails.in_question_master_id) || errors.has('txt_'+controlData.queDetails.in_question_master_id)) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_INPUT"
              >
                <label class="persnol-info-title">
                  {{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                  <a
                    @click.prevent
                    data-toggle="tooltip"
                    data-placement="top"
                    v-if="controlData.queDetails.st_question_hint != null"
                  >
                    <i
                      class="fa fa-info-circle"
                      v-tooltip.right="controlData.queDetails.st_question_hint"
                      v-if="controlData.validationDetailsObj[9]"
                    ></i>
                  </a>
                </label>
                <!-- Paragraph -->
                <div class="group" v-if="controlData.validationDetailsObj[8]">
                  <div class="text-wrap-new">
                    <div class="form-group" v-if="controlData.validationDetailsObj[49]">
                      <input
                        type="hidden"
                        :key="'map'+controlData.queDetails.in_question_master_id"
                        :name="'map_'+controlData.queDetails.in_question_master_id"
                        v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      />
                      <mapbox-autocomplete
                        :id="'map_'+controlData.queDetails.in_question_master_id"
                        :ref="'map_'+controlData.queDetails.in_question_master_id"
                        placeholder="Enter a location"
                        :value="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].formatted_address : ''"
                        v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.queDetails.in_question_master_id), error: handleError, inputChange: (inputValue, id) => (onMapInputChange(inputValue, id, controlData.queDetails.in_question_master_id))}"
                      ></mapbox-autocomplete>
                      <div>
                        <b-dropdown
                        class="m-md-2 set-dropdown"
                        :name="'drpdwn_'+controlData.queDetails.in_question_master_id"
                        >
                          <b-dropdown-item v-for="(item, key) in allSurveyAnswerData[controlData.queDetails.in_question_master_id]" :key="key" @click="setValueinText(controlData.queDetails.in_question_master_id, $event)">
                            {{ item }}
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <span
                        v-show="errors.has('map_'+controlData.queDetails.in_question_master_id)"
                        class="error"
                      >{{ errors.first('map_'+controlData.queDetails.in_question_master_id) }}</span>
                    </div>
                    <div class="form-group" v-else>
                      <textarea
                        class="form-control"
                        rows="5"
                        placeholder="Answer here"
                        :name="'txt_'+controlData.queDetails.in_question_master_id"
                        v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                        v-validate="{min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : ''}"
                        data-vv-as="above"
                      ></textarea>
                      <div>
                        <b-dropdown
                        class="m-md-2 set-dropdown"
                        :name="'drpdwn_'+controlData.queDetails.in_question_master_id"
                        >
                          <b-dropdown-item v-for="(item, key) in allSurveyAnswerData[controlData.queDetails.in_question_master_id]" :key="key" @click="setValueinText(controlData.queDetails.in_question_master_id, $event)">
                            {{ item }}
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <span
                        v-show="errors.has('txt_'+controlData.queDetails.in_question_master_id)"
                        class="error"
                      >{{ errors.first('txt_'+controlData.queDetails.in_question_master_id) }}</span>
                    </div>
                  </div>
                </div>
                <!-- Serial Number -->
                <div class="group" v-else-if="controlData.validationDetailsObj[9]">
                  <input
                    type="text"
                    placeholder="Answer here"
                    :name="'txt_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : '', custom_regex: controlData.validationDetailsObj[10] ? ([controlData.validationDetailsObj[10]['source'],controlData.queDetails.st_question_hint]) : ''}"
                    data-vv-as="above"
                    @input="controlData.validationDetailsObj[1] ? (checkInput(controlData.queDetails.in_question_master_id, $event), '') : ''"
                  />
                  <div>
                    <b-dropdown
                    class="m-md-2 set-dropdown"
                    :name="'drpdwn_'+controlData.queDetails.in_question_master_id"
                    >
                      <b-dropdown-item v-for="(item, key) in allSurveyAnswerData[controlData.queDetails.in_question_master_id]" :key="key" @click="setValueinText(controlData.queDetails.in_question_master_id, $event)">
                        {{ item }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <span
                    v-show="errors.has('txt_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('txt_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                <!-- Single Line -->
                <div class="group add-dropdown" v-else-if="controlData.validationDetailsObj[6]">
                  <div v-if="controlData.validationDetailsObj[49]">
                    <input
                      type="hidden"
                      :key="'map'+controlData.queDetails.in_question_master_id"
                      :name="'map_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    />
                    <mapbox-autocomplete
                      :id="'map_'+controlData.queDetails.in_question_master_id"
                      :ref="'map_'+controlData.queDetails.in_question_master_id"
                      placeholder="Enter a location"
                      :value="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].formatted_address : ''"
                      v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.queDetails.in_question_master_id), error: handleError, inputChange: (inputValue, id) => (onMapInputChange(inputValue, id, controlData.queDetails.in_question_master_id))}"
                    ></mapbox-autocomplete>
                    <div>
                      <b-dropdown
                      class="m-md-2 set-dropdown"
                      :name="'drpdwn_'+controlData.queDetails.in_question_master_id"
                      >
                        <b-dropdown-item v-for="(item, key) in allSurveyAnswerData[controlData.queDetails.in_question_master_id]" :key="key" @click="setValueinText(controlData.queDetails.in_question_master_id, $event)">
                          {{ item }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <span
                      v-show="errors.has('map_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('map_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                  <div v-else>
                    <input
                      type="text"
                      placeholder="Answer here"
                      :name="'txt_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      v-validate="{min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : ''}"
                      data-vv-as="above"
                    />

                    <div>
                      <b-dropdown
                      class="m-md-2 set-dropdown"
                      :name="'drpdwn_'+controlData.queDetails.in_question_master_id"
                      >
                        <b-dropdown-item v-for="(item, key) in allSurveyAnswerData[controlData.queDetails.in_question_master_id]" :key="key" @click="setValueinText(controlData.queDetails.in_question_master_id, $event)">
                          {{ item }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <span
                      v-show="errors.has('txt_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('txt_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                </div>
              </div>
              <div
                class="persnol-info-main qus_ans_sec"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_DISPLAY"
              >
                <blockquote class="ludwig">
                  <div class="mb-10">
                    <label
                      class="persnol-info-title set-margin-zero"
                    >{{controlData.queDetails.st_question_title}}</label>
                    </div>
                </blockquote>
                <blockquote class="ludwig-subtitle" v-if="controlData.validationDetailsObj[11] ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] = controlData.validationDetailsObj[11] : ''">
                  <div class="mb-10">
                    <p
                    >{{controlData.validationDetailsObj[11]}}</p>
                  </div>
                </blockquote>
              </div>
              <!-- END for text question type -->
              <!-- ********************* -->
              <!-- START for barcode question type -->
                <div
                  class="persnol-info-main qus_ans_sec"
                  :class="{ 'red-border': (errors.has('map_'+controlData.queDetails.in_question_master_id) || errors.has('txt_'+controlData.queDetails.in_question_master_id)) }"
                  v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER"
                >
                  <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                    {{controlData.queDetails.st_question_title}}
                    <a
                      @click.prevent
                      data-toggle="tooltip"
                      data-placement="top"
                      v-if="controlData.queDetails.st_question_hint != null"
                    >
                      <i
                        class="fa fa-info-circle"
                        v-tooltip.right="controlData.queDetails.st_question_hint"
                        v-if="controlData.validationDetailsObj[9]"
                      ></i>
                    </a>
                  </label>
                  <div class="group add-dropdown">
                    <input
                      type="text"
                      placeholder="Answer here"
                      :name="'barcode_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      v-validate="{min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : ''}"
                      data-vv-as="above"
                    />

                    <div>
                      <b-dropdown
                      class="m-md-2 set-dropdown"
                      :name="'drpdwn_'+controlData.queDetails.in_question_master_id"
                      >
                        <b-dropdown-item v-for="(item, key) in allSurveyAnswerData[controlData.queDetails.in_question_master_id]" :key="key" @click="setValueinText(controlData.queDetails.in_question_master_id, $event)">
                          {{ item }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <span
                      v-show="errors.has('txt_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('txt_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
              </div>
              <!-- END for barcode question type -->
              <!-- ********************* -->
              <!-- START for List question type -->
              <div class="qus_ans_sec" v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_LIST" :class="{ 'red-border': (errors.has('multiselect_'+controlData.queDetails.in_question_master_id) || errors.has('map_'+controlData.queDetails.in_question_master_id) || errors.has('chkOther_'+controlData.queDetails.in_question_master_id)) }">
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="answer_sec">
                  <multi-select
                    :name="'multiselect_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    tag-placeholder="Add this as new option"
                    placeholder="Answer here"
                    deselect-label="Can't remove this value"
                    :options="emojiSplitJoin(controlData.validationDetailsObj[6], '\n', controlData.validationDetailsObj['extra']['lat'], controlData.validationDetailsObj['extra']['lng'], controlData.validationDetailsObj['extra']['score'], controlData.queDetails.in_question_type_id)"
                    v-on="{input : (selectedOption, id) => checkMultipleChoice(selectedOption, id, controlData.queDetails.in_question_master_id, index, controlData.validationDetailsObj[1])}"
                    track-by="formatted_address"
                    label="formatted_address"
                    :allow-empty="false"
                  ></multi-select>
                  <span
                    v-show="errors.has('multiselect_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('multiselect_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                <div class="persnol-info-main" v-if="controlData.queDetails.other">
                  <div class="group list-qus-sec" v-if="controlData.validationDetailsObj[49]">
                    <input
                      type="hidden"
                      :key="'map'+controlData.queDetails.in_question_master_id"
                      :name="'map_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id]"
                    />
                    <mapbox-autocomplete
                      :id="'map_'+controlData.queDetails.in_question_master_id"
                      :ref="'map_'+controlData.queDetails.in_question_master_id"
                      placeholder="Enter a location"
                      :value="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id] ? previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id].formatted_address : ''"
                      v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.queDetails.in_question_master_id, controlData.queDetails.in_question_type_id), error: handleError, inputChange: (inputValue, id) => onMapInputChange(inputValue, id, controlData.queDetails.in_question_master_id, controlData.queDetails.in_question_type_id)}"
                    ></mapbox-autocomplete>
                    <span
                      v-show="errors.has('map_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('map_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                  <div class="group list-qus-sec" v-else>
                    <input
                      type="text"
                      :name="'chkOther_'+controlData.queDetails.in_question_master_id"
                      data-vv-as="above"
                      class="pac-target-input"
                      v-validate="{required: true,max:80}"
                      placeholder="Enter your other answer"
                      :value="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id] ? previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id].formatted_address : ''"
                      @input="checkListOther(controlData.queDetails.in_question_master_id, $event)"
                    />
                    <div>
                      <span
                        v-show="errors.has('chkOther_'+controlData.queDetails.in_question_master_id)"
                        class="error"
                      >{{ errors.first('chkOther_'+controlData.queDetails.in_question_master_id) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- END for List question type -->
              <!-- ********************* -->
              <!-- START for email question type -->
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': errors.has('txt_email_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_EMAIL"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group email_sec">
                  <i aria-hidden="true" class="fas fa-envelope"></i>
                  <input
                    type="text"
                    placeholder="Answer here"
                    :name="'txt_email_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{email: true}"
                    data-vv-as="above"
                    :data-email-survey="controlData.validationDetailsObj[22]"
                    @blur="validateEmail('txt_email_'+controlData.queDetails.in_question_master_id, $event)"
                  />
                  <div>
                    <b-dropdown
                    class="m-md-2 set-dropdown"
                    :name="'drpdwn_'+controlData.queDetails.in_question_master_id"
                    >
                      <b-dropdown-item v-for="(item, key) in allSurveyAnswerData[controlData.queDetails.in_question_master_id]" :key="key" @click="setValueinText(controlData.queDetails.in_question_master_id, $event)">
                        {{ item }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <span
                    v-show="errors.has('txt_email_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('txt_email_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <!-- END email question type -->
              <!-- ********************* -->
              <!-- START for two choices question type -->
              <div
                class="selection-gender qus_ans_sec"
                :class="{ 'red-border': errors.has('rb_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_OTHER"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group">
                <label class="selection-main">
                  {{(controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'Yes' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'True' : controlData.validationDetailsObj[40]}}
                  <input
                    type="radio"
                    :name="'rb_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    :value="{value: (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'yes' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'true' : controlData.validationDetailsObj[40], score: (controlData.validationDetailsObj['extra'] && controlData.validationDetailsObj['extra'][0] ? controlData.validationDetailsObj['extra'][0]['score'] : '')}"
                    @click="uncheck(controlData.queDetails.in_question_master_id, (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'yes' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'true' : controlData.validationDetailsObj[40])"
                  />
                  <span class="checkmark-new checkradio-new"></span>
                </label>
                <label class="selection-main">
                  {{(controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'No' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'False' : controlData.validationDetailsObj[41]}}
                  <input
                    type="radio"
                    :name="'rb_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    :value="{value: (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'no' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'false' : controlData.validationDetailsObj[41], score: (controlData.validationDetailsObj['extra'] && controlData.validationDetailsObj['extra'][1] ? controlData.validationDetailsObj['extra'][1]['score'] : '')}"
                    @click="uncheck(controlData.queDetails.in_question_master_id, (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_YES_NO) ? 'no' : (controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TRUE_FALSE) ? 'false' : controlData.validationDetailsObj[41])"
                  />
                  <span class="checkmark-new checkradio-new"></span>
                </label>
                <div>
                  <span
                    v-show="errors.has('rb_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('rb_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                </div>
              </div>
              <!-- END for two choices question type -->
              <!-- ********************* -->
              <!-- START Number question type -->
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': errors.has('txt_number_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CURRENCY || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_NUMBER"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <!-- Currency and Numbers -->
                <div class="group">
                  <span
                    class="currency"
                    v-if="controlData.validationDetailsObj[27]"
                  >{{controlData.validationDetailsObj[27]}}</span> 
                  <input
                    type="text"
                    placeholder="Answer here"
                    :name="'txt_number_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{decimal: controlData.validationDetailsObj[28] ? 2 : false, integer: controlData.validationDetailsObj[28] ? false : true, custom_min_value: controlData.validationDetailsObj[4] ? controlData.validationDetailsObj[4] : '', custom_max_value: controlData.validationDetailsObj[5] ? controlData.validationDetailsObj[5] : ''}"
                    data-vv-as="above"
                    :style="{ 'padding-left': controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CURRENCY ? '60px' : '20px'}"
                  />
                  <div>
                    <b-dropdown
                    class="m-md-2 set-dropdown"
                    :name="'drpdwn_'+controlData.queDetails.in_question_master_id"
                    >
                      <b-dropdown-item v-for="(item, key) in allSurveyAnswerData[controlData.queDetails.in_question_master_id]" :key="key" @click="setValueinText(controlData.queDetails.in_question_master_id, $event)">
                        {{ item }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <span
                    v-show="errors.has('txt_number_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('txt_number_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': errors.has('txt_number_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TELEPHONE"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                  <a
                    @click.prevent
                    data-toggle="tooltip"
                    data-placement="top"
                    v-if="controlData.queDetails.st_question_hint != null"
                  >
                    <i
                      class="fa fa-info-circle"
                      v-tooltip.right="controlData.queDetails.st_question_hint"
                    ></i>
                  </a>
                </label>
                <!-- Telephone -->
                <div class="group">
                  {{controlData.validationDetailsObj[27] ? controlData.validationDetailsObj[27] : ''}}
                  <i class="fa fa-phone"></i>
                  <input
                    type="text"
                    placeholder="Answer here"
                    :name="'txt_number_'+controlData.queDetails.in_question_master_id"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    v-validate="{min: controlData.validationDetailsObj[2] ? controlData.validationDetailsObj[2] : '', custom_max: controlData.validationDetailsObj[3] ? controlData.validationDetailsObj[3] : '',  custom_regex: controlData.validationDetailsObj[26] ? ([controlData.validationDetailsObj[26]['source'],controlData.queDetails.st_question_hint]) : ['^[0-9]+$', 'Allowed characters: 0-9'] }"
                    data-vv-as="above"
                  />
                  <div>
                    <b-dropdown
                    class="m-md-2 set-dropdown"
                    :name="'drpdwn_'+controlData.queDetails.in_question_master_id"
                    >
                      <b-dropdown-item v-for="(item, key) in allSurveyAnswerData[controlData.queDetails.in_question_master_id]" :key="key" @click="setValueinText(controlData.queDetails.in_question_master_id, $event)">
                        {{ item }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <span
                    v-show="errors.has('txt_number_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('txt_number_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <!-- END for Number question type -->
              <!-- ********************* -->
              <!-- START Terms & Condition question type -->
              <div
                class="persnol-info-main selection-gender qus_ans_sec term-sec"
                :class="{ 'red-border': errors.has('rb_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_TERMS_AND_CONDITIONS"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group">
                  <div class="text-wrap-new" v-if="controlData.validationDetailsObj[12]">
                    <textarea rows="5" class="form-control" readonly>{{controlData.validationDetailsObj[12]}}</textarea>
                  </div>
                  <label
                    class="selection-main"
                    v-for="(val, i) in controlData.validationDetailsObj[19]"
                    :key="i"
                  >
                    {{val}}
                    <input
                      type="radio"
                      :name="'rb_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      :value="val"
                      @click="uncheck(controlData.queDetails.in_question_master_id, val)"
                    />
                    <span class="checkmark-new checkradio-new"></span>
                  </label>
                </div>
                
                <div>
                  <span
                    v-show="errors.has('rb_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('rb_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <!-- END for Terms & Condition question type -->
              <!-- ********************* -->
              <!-- START Date question type -->
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': errors.has('datepicker_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_DATE"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group">
                  <date-picker
                    value-type="format"
                    v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                    :name="'datepicker_'+controlData.queDetails.in_question_master_id"
                    :not-before="controlData.validationDetailsObj[30] ? controlData.validationDetailsObj[30] : ''"
                    :not-after="controlData.validationDetailsObj[31] ? controlData.validationDetailsObj[31] : ''"
                    :format="controlData.validationDetailsObj[42] ? controlData.validationDetailsObj[42] : 'DD-MM-YYYY' "
                    :first-day-of-week="1"
                    :lang="lang"
                    data-vv-as="above"
                    data-id="date_field"
                    v-on="{ input: controlData.validationDetailsObj[1] ? (currentValue) => (checkDateTimePicker(currentValue, controlData.queDetails.in_question_master_id)) : null }"
                    input-class
                  ></date-picker>
                  <div>
                    <span
                      v-show="errors.has('datepicker_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('datepicker_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                </div>
              </div>
              <!-- END for Date question type -->
              <!-- START Time question type -->
              <div
                class="persnol-info-main qus_ans_sec"
                :class="{ 'red-border': errors.has('timepicker_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_24_HOURS"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group timepicker-container" v-if="!previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] ? (previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] = moment().format('HH:mm:ss'), true) : true">
                  <v-app>
                    <v-dialog
                      :ref="'dialog_'+controlData.queDetails.in_question_master_id"
                      v-model="timePickerObject[controlData.queDetails.in_question_master_id]"
                      :return-value.sync="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      persistent
                      width="330px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          solo
                          single-line
                          v-model="tempTimePickerValue[''+controlData.queDetails.in_question_master_id]"
                          :name="'timepicker_'+controlData.queDetails.in_question_master_id"
                          @click:clear="clearTimepickerValue(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[1], '', index)"
                          v-bind="attrs"
                          v-on="on"
                          label="Select Time"
                          prepend-inner-icon="mdi-clock"
                          readonly
                          clearable
                          hide-details="auto"
                          rounded
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="timePickerObject[controlData.queDetails.in_question_master_id]"
                        v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                        :data="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                        v-on="{ input: controlData.validationDetailsObj[1] ? (currentValue) => (checkDateTimePicker(currentValue, controlData.queDetails.in_question_master_id)) : null }"
                        :format="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? 'ampm' : '24hr'"
                        :min="controlData.validationDetailsObj[32] ? controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? moment(controlData.validationDetailsObj[32], timeFormat12).format(timeFormat24) : controlData.validationDetailsObj[32]
                          : undefined"
                        :max="controlData.validationDetailsObj[33] ? controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_12_HOURS ? moment(controlData.validationDetailsObj[33], timeFormat12).format(timeFormat24) : controlData.validationDetailsObj[33]
                          : undefined"
                        use-seconds
                        full-width
                        ampm-in-title
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="unsetTimePickerValue(controlData.queDetails.in_question_master_id)">
                          Cancel
                        </v-btn>
                        <v-btn text color="primary" @click="setTimePickerValue(2, controlData.queDetails.in_question_type_id, controlData.queDetails.in_question_master_id, '', index)">
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-app>
                  <div>
                    <span
                      v-show="errors.has('timepicker_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('timepicker_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                </div>
              </div>
              <!-- END for Time question type -->
              <!-- ********************* -->
              <!-- START Multiple choice question type - Text -->
              <!-- Allow more than one answer -> checkbox else radio button -->
              <div
                class="selection-gender qus_ans_sec"
                :class="{ 'red-border': (errors.has('chk_'+controlData.queDetails.in_question_master_id) || errors.has('map_'+controlData.queDetails.in_question_master_id) || errors.has('chkOther_'+controlData.queDetails.in_question_master_id)) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_MULTIPLE_TEXT"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group">
                <label
                  class="check-label"
                  v-for="(val, i) in controlData.validationDetailsObj[14]"
                  :key="i"
                >
                  {{val.answer}}
                  <input
                    :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                    :name="'chk_'+controlData.queDetails.in_question_master_id"
                    :value="val.answer"
                    :checked="previewSurveyData['chkMapMulChoice'][controlData.queDetails.in_question_master_id] && (previewSurveyData['chkMapMulChoice'][controlData.queDetails.in_question_master_id].formatted_address == val.answer  || ( !previewSurveyData['chkMapMulChoice'][controlData.queDetails.in_question_master_id].formatted_address && (previewSurveyData['chkMapMulChoice'][controlData.queDetails.in_question_master_id]).map(y=>y['formatted_address']).includes(val.answer) ) ) ? true : false"
                    @click="checkOtherAnswer(index, controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[49], $event)"
                    @change="setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event)"
                    :data-lat="val.lat"
                    :data-lng="val.lng"
                    :data-score="val.score"
                  />
                  <span class="checkmark check-mark-two"></span>
                </label>
                <!-- Allow other answer -->
                <label class="check-label" v-if="controlData.validationDetailsObj[13]">
                  Other
                  <input
                    :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                    :name="'chk_'+controlData.queDetails.in_question_master_id"
                    v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                    data-vv-as="above"
                    value="Other"
                    :checked="controlData.queDetails.other ? true : false"
                    @click="checkOtherAnswer(index, controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[49], $event)"
                    @change="controlData.validationDetailsObj[1] ? (checkCheckbox(controlData.queDetails.in_question_master_id, $event), setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event)) : setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event)"
                  />
                  <span class="checkmark check-mark-two"></span>
                </label>
                <div>
                  <span
                    v-show="errors.has('chk_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('chk_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                <div class="persnol-info-main other-opt" v-if="controlData.queDetails.other">
                  <div class="group" v-if="controlData.validationDetailsObj[49]">
                    <input
                      type="hidden"
                      :key="'map'+controlData.queDetails.in_question_master_id"
                      :name="'map_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id]"
                    />
                    <mapbox-autocomplete
                      :id="'map_'+controlData.queDetails.in_question_master_id"
                      :ref="'map_'+controlData.queDetails.in_question_master_id"
                      :data-score="controlData.validationDetailsObj[13] ? controlData.validationDetailsObj[13][0]['score'] : ''"
                      placeholder="Enter a location"
                      :value="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id] ? previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id].formatted_address : ''"
                      v-on="{placechanged: (addressData, placeResultData, id) => getAddressData(controlData.validationDetailsObj[1], addressData, placeResultData, id, controlData.queDetails.in_question_master_id, controlData.queDetails.in_question_type_id), error: handleError, inputChange: (inputValue, id) => (  (inputValue, id, controlData.queDetails.in_question_master_id, controlData.queDetails.in_question_type_id))}"
                    ></mapbox-autocomplete>
                    <span
                      v-show="errors.has('map_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('map_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                  <div class="group list-qus-sec" v-else>
                    <input
                      type="text"
                      :name="'chkOther_'+controlData.queDetails.in_question_master_id"
                      :data-score="controlData.validationDetailsObj[13] ? controlData.validationDetailsObj[13][0]['score'] : ''"
                      :value="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id] ? previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id].formatted_address : ''"
                      data-vv-as="above"
                      class="pac-target-input"
                      v-validate="{required: true,max:80}"
                      placeholder="Enter your other answer"
                      @input="checkOtherAnswer(index, controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[49], $event)"
                    />
                    <div>
                      <span
                        v-show="errors.has('chkOther_'+controlData.queDetails.in_question_master_id)"
                        class="error"
                      >{{ errors.first('chkOther_'+controlData.queDetails.in_question_master_id) }}</span>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
              <!-- Multiple choice question type - Image -->
                <!-- class="image-selection multichoicequs-sec" -->
              <div
                class="image-selection multichoicequs-sec"
                :class="{ 'red-border': (errors.has('chk_image_'+controlData.queDetails.in_question_master_id) || errors.has('chkOther_image_'+controlData.queDetails.in_question_master_id)) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_MULTIPLE_IMAGE"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <label class="selectonelabel" v-if="!controlData.validationDetailsObj[20]">Select One</label>
                <div class="row">
                  <div 
                    class="col-md-3"
                    v-for="(imageValue, imageIndex) in controlData.validationDetailsObj[15]"
                  >
                  <div :class="(controlData.validationDetailsObj[20] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].includes(imageValue.s3ImagePath) || previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] == imageValue.s3ImagePath) ? 'multichoicequs-div active' : 'multichoicequs-div'">
                    <i class="checked-circle"></i>
                    <label class="imageContainer">
                      <input
                        :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                        :name="'chk_image_'+controlData.queDetails.in_question_master_id"
                        :value="imageValue.s3ImagePath"
                        class="hidden"
                        autocomplete="off"
                        @click="checkOtherAnswer(index, controlData.queDetails.in_question_master_id, true, $event)"
                        @change="setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event)"
                        :data-score="imageValue.score"
                        :checked="tempPreviouslySelected[controlData.queDetails.in_question_master_id]===imageValue.s3ImagePath"
                      />
                      <img
                        :src="imageValue.dataURL"
                        alt="..."
                        class="profileImagePreview img-check"
                      />
                    </label>
                    <div class="multichoice-text text-center" v-if="controlData.validationDetailsObj[21] && imageValue.st_answer_label">
                      <span class="iteam-select">{{imageValue.st_answer_label}}</span>
                    </div>
                  </div>
                  </div>
                  <div class="col-md-3" v-if="controlData.validationDetailsObj[13]">
                    <div :class="(controlData.validationDetailsObj[20] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].includes('Other') || previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] == 'Other') ? 'multichoicequs-div other-block active' : 'multichoicequs-div other-block'">
                      <i class="checked-circle"></i>
                      <label class="imageContainer">
                        <input
                          :type="controlData.validationDetailsObj[20] ? 'checkbox' : 'radio'"
                          :key="'chkrb'+controlData.queDetails.in_question_master_id"
                          :name="'chk_image_'+controlData.queDetails.in_question_master_id"
                          v-validate="{required: controlData.validationDetailsObj[1] ? true : false}"
                          data-vv-as="above"
                          value="Other"
                          @click="checkOtherAnswer(index, controlData.queDetails.in_question_master_id, true, $event)"
                          @change="setModelValueForMultipleAns(controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[20], $event)"
                          :checked="tempPreviouslySelected[controlData.queDetails.in_question_master_id]==='Other'"
                        />

                        <img
                          src="../../assets/images/other_image.png"
                          alt="..."
                          class="profileImagePreview img-check"
                        />
                      </label>
                      <div class="multichoice-text text-center" v-if="controlData.validationDetailsObj[21]">
                        <span class="iteam-select">Other</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <span
                    v-show="errors.has('chk_image_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('chk_image_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
                <div class="persnol-info-main" v-if="controlData.queDetails.other">
                  <div class="group">
                    <input
                      type="text"
                      class="form-imput-text"
                      :name="'chkOther_image_'+controlData.queDetails.in_question_master_id"
                      data-vv-as="above"
                      :data-score="controlData.validationDetailsObj[13] ? controlData.validationDetailsObj[13][0]['score'] : ''"
                      :value="previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id] ? previewSurveyData['chkOtherMulChoice'][''+controlData.queDetails.in_question_master_id].formatted_address : ''"
                      v-validate="{required: true,max:80}"
                      placeholder="Enter your other answer"
                      @input="checkOtherAnswer(quesNo, controlData.queDetails.in_question_master_id, controlData.validationDetailsObj[49], $event)"
                    />
                    <div>
                      <span
                        v-show="errors.has('chkOther_image_'+controlData.queDetails.in_question_master_id)"
                        class="error"
                      >{{ errors.first('chkOther_image_'+controlData.queDetails.in_question_master_id) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- END for Multiple choice question type -->
              <!-- ********************* -->
              <!-- START Image question type -->
              <div
                class="image-selection" style="padding: 0;"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_IMAGE ? previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] = [] : 0"
              >
                <label class="persnol-info-title" v-if="controlData.validationDetailsObj[35]">
                  {{controlData.queDetails.st_question_title}}
                </label>
                <!-- In one column -->
                <div class="row" v-if="controlData.validationDetailsObj[34] == 0">
                  <div
                    :class="[controlData.validationDetailsObj[15].length == 1 ? 'col-md-12' : (controlData.validationDetailsObj[15].length == 2 ? 'col-md-6' : (controlData.validationDetailsObj[15].length == 3 ? 'col-md-4' : 'col-md-3'))]"
                    v-for="(imageValue, imageIndex) in controlData.validationDetailsObj[15]"
                    :key="imageIndex"
                  >
                  <div class="multichoicequs-div">
                    <label class="imageContainer">
                      <img
                        :src="imageValue.dataURL"
                        alt="..."
                        class="profileImagePreview img-check"
                      />
                    </label>
                  </div>
                  </div>
                </div>
                <!-- In one row -->
                <div
                  class="row"
                  v-else
                  v-for="(imageValue, imageIndex) in controlData.validationDetailsObj[15]"
                  :key="imageIndex"
                >
                  <div class="col-md-12">
                    <label class="imageContainer single-img">
                      <img
                        :src="imageValue.dataURL"
                        alt="..."
                        class="profileImagePreview img-check"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <!-- END Image question type -->
              <!-- ********************* -->
              <!-- START Rating question type - Star Rating-->
              <div
                class="star-rating-wrap"
                :class="{ 'red-border': errors.has('rb_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_STAR ? emojiStarScore = emojiSplitJoin(controlData.validationDetailsObj['extra']['score'], '\n') : 0"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <label class="selectonelabel" v-if="!controlData.validationDetailsObj[20]">Select One</label>
                <fieldset class="rating">
                  <label
                    v-for="(rating, ind) in parseInt(controlData.validationDetailsObj[38])"
                    :key="ind"
                    v-bind:style="{ 'z-index': parseInt(controlData.validationDetailsObj[38]) - ind }"
                  >
                    <input
                      type="radio"
                      :id="'star'+(ind+1)"
                      :key="'rb'+controlData.queDetails.in_question_master_id"
                      :name="'rb_'+controlData.queDetails.in_question_master_id"
                      v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"
                      v-validate="{required: ind == 0 && controlData.validationDetailsObj[1] ? true : false}"
                      :value="{value: ind+1, score: (emojiStarScore[ind]) ? emojiStarScore[ind] : ''}"
                      data-vv-as="above"
                      @input="emojiStarScore = emojiSplitJoin(controlData.validationDetailsObj['extra']['score'], '\n')"
                    />
                    <span class="icon" v-for="i in (ind+1)" :key="i">â˜…</span>
                  </label>
                </fieldset>
                <div>
                  <span
                    v-show="errors.has('rb_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('rb_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <!-- START Rating question type - Satisfaction Rating-->
              <div
                class="emoji-rates-wrap image-selection"
                :class="{ 'red-border': errors.has('chk_satis_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_SATISFACTION ? emojiScore = emojiSplitJoin(controlData.validationDetailsObj['extra']['score'], '\n') : 0"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div id="question-1">
                  <ul class="emoji-choices">
                    <li
                      class="choice"
                      v-for="(emojiValue, emojiIndex) in emojiSplitJoin(controlData.validationDetailsObj[39], 'sep')"
                      :data-value="emojiIndex+1"
                      :key="emojiIndex"
                    >
                      <label
                        :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].value == ':P' ? 'emoji emoji-selected' : 'emoji'"
                        v-if="emojiValue == ':P'"
                      >
                        <input
                          type="radio"
                          :name="'chk_satis_'+controlData.queDetails.in_question_master_id"
                          data-vv-as="above"
                          class="hidden"
                          autocomplete="off"
                          value=":P"
                          :data-score="(emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''"
                          @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event)"
                        />
                        <i class="em em-heart_eyes"></i>
                      </label>
                      <label
                        :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].value == ':)' ? 'emoji emoji-selected' : 'emoji'"
                        v-if="emojiValue == ':)'"
                      >
                        <input
                          type="radio"
                          :name="'chk_satis_'+controlData.queDetails.in_question_master_id"
                          data-vv-as="above"
                          class="hidden"
                          autocomplete="off"
                          value=":)"
                          :data-score="(emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''"
                          @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event)"
                        />
                        <i class="em em-smile"></i>
                      </label>
                      <label
                        :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].value == ':|' ? 'emoji emoji-selected' : 'emoji'"
                        v-if="emojiValue == ':|'"
                      >
                        <input
                          type="radio"
                          :name="'chk_satis_'+controlData.queDetails.in_question_master_id"
                          data-vv-as="above"
                          class="hidden"
                          autocomplete="off"
                          value=":|"
                          :data-score="(emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''"
                          @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event)"
                        />
                        <i class="em em-neutral_face"></i>
                      </label>
                      <label
                        :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].value == ':(' ? 'emoji emoji-selected' : 'emoji'"
                        v-if="emojiValue == ':('"
                      >
                        <input
                          type="radio"
                          :name="'chk_satis_'+controlData.queDetails.in_question_master_id"
                          data-vv-as="above"
                          class="hidden"
                          autocomplete="off"
                          value=":("
                          :data-score="(emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''"
                          @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event)"
                        />
                        <i class="em em-disappointed"></i>
                      </label>
                      <label
                        :class="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] && previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id].value == ':@' ? 'emoji emoji-selected' : 'emoji'"
                        v-if="emojiValue == ':@'"
                      >
                        <input
                          type="radio"
                          :name="'chk_satis_'+controlData.queDetails.in_question_master_id"
                          data-vv-as="above"
                          class="hidden"
                          autocomplete="off"
                          value=":@"
                          :data-score="(emojiScore[emojiIndex]) ? emojiScore[emojiIndex] : ''"
                          @click="onStarAndEmojiClick(controlData.queDetails.in_question_master_id, $event)"
                        />
                        <i class="em em-angry"></i>
                      </label>
                    </li>
                  </ul>
                  <div class="clearfix"></div>
                  <div>
                    <span
                      v-show="errors.has('chk_satis_'+controlData.queDetails.in_question_master_id)"
                      class="error"
                    >{{ errors.first('chk_satis_'+controlData.queDetails.in_question_master_id) }}</span>
                  </div>
                </div>
              </div>
              <!-- END Rating question type -->
              <!-- ********************* -->
              <!-- START Photo question type -->
              <div
                class="image-selection multichoicequs-sec"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_CAMERA || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_QR_AND_BARCODE_READER"
              >
                 <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="row">
                  <div class="col-md-3">
                    <div class="multichoicequs-div" v-if="arrShowAllPhotoQuestion[controlData.queDetails.in_question_master_id]">
                      <label class="imageContainer">
                        <img
                          :src="previewSurveyData.chkSurveyQuestionDetails[controlData.queDetails.in_question_master_id]"
                          alt="..."
                          class="profileImagePreview img-check"
                        />
                      </label>
                      <i
                        @click="removeOldPhoto(controlData.queDetails.in_question_master_id, previewSurveyData.chkSurveyQuestionDetails[controlData.queDetails.in_question_master_id], $event)"
                        class="fa fa-times multiplechoice-cross"
                        aria-hidden="true"
                      ></i>
                    </div>
                    <div class="multichoicequs-div" v-else>
                      <label for="photoedit" class="imageContainer photoquestionIcon">
                        <input type="file" id="photoedit" @change="uploadPhoto(controlData.queDetails.in_question_master_id, $event)" name="btnPhotoUpload" />
                        <div class="item-inner">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 26 26">
                          <path class="whitelabelsvg" fill-rule="evenodd" d="M12.853 3.11c-.722.067-1.226.618-1.226 1.367l-.001 7.149H4.477c-.799 0-1.373.575-1.373 1.374l.007.147c.066.722.617 1.226 1.366 1.226h7.149v7.15c0 .799.575 1.373 1.374 1.373l.147-.007c.722-.066 1.226-.617 1.226-1.366v-7.15h7.15c.799 0 1.373-.574 1.373-1.373l-.007-.147c-.066-.722-.617-1.226-1.366-1.226l-7.15-.001V4.477c0-.799-.574-1.373-1.373-1.373l-.147.007z"></path></svg></div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- END Photo question type -->
              <!-- ********************* -->
              <!-- START Audio/Video question type -->
              <div
                class="image-selection multichoicequs-sec"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_AUDIO || controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_VIDEO"
              >
                 <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <div class="group persnol-info-main qus_ans_sec disabled-question-none" >
                  <input
                    type="text"
                    placeholder="This question is not availible for preview."
                    readonly
                  />
                </div>
              </div>
              <!-- END Audio/Video question type -->
              <!-- ********************* -->
              <!-- START Signature question type -->
              <div
                class="image-selection padding0"
                :class="{ 'red-border': errors.has('signature_'+controlData.queDetails.in_question_master_id) }"
                v-if="controlData.queDetails.in_question_type_id == vueQueTypeConfig.TYPE_SIGNATURE"
              >
                <label class="persnol-info-title">{{controlData.queDetails.in_question_number + '.'}}
                  {{controlData.queDetails.st_question_title}}
                </label>
                <input
                  type="hidden"
                  :name="'signature_'+controlData.queDetails.in_question_master_id"
                  v-model="previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id]"                  
                  data-vv-as="above"
                />
                <div class="group signature_sec">
                  <button type="button" class="btn sub-main edit-signature">
                    <svg class="edit-img" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      width="26.688px" height="26.563px" viewBox="0 -0.563 26.688 26.563" enable-background="new 0 -0.563 26.688 26.563"
                      xml:space="preserve">
                      <g>
                        <g>
                          <path d="M20.127,4.158c0-0.61-0.237-1.184-0.669-1.616l-2.154-2.154c-0.425-0.425-1.029-0.669-1.63-0.669h-0.131v4.57h4.584V4.158
                            L20.127,4.158z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M14.258,15.438c0.146-0.443,0.4-0.855,0.732-1.189l5.158-5.136V5.813h-5.354c-0.42,0-0.736-0.341-0.736-0.762v-5.332
                            H2.633c-1.26,0-2.285,1.025-2.285,2.285v21.43c0,1.26,1.025,2.285,2.285,2.285h15.209c1.261,0,2.307-1.025,2.307-2.285v-5.686
                            l-0.838,0.817c-0.339,0.336-0.736,0.581-1.184,0.73l-2.422,0.809l-0.369,0.021c-0.61,0-1.188-0.297-1.546-0.795
                            c-0.355-0.494-0.452-1.135-0.259-1.715L14.258,15.438z M4.157,13.43h7.592c0.421,0,0.762,0.341,0.762,0.762
                            s-0.34,0.762-0.762,0.762H4.157c-0.421,0-0.762-0.341-0.762-0.762S3.736,13.43,4.157,13.43z M3.395,11.145
                            c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762H4.157
                            C3.736,11.906,3.395,11.565,3.395,11.145z M3.395,17.238c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762
                            S12.17,18,11.749,18H4.157C3.736,18,3.395,17.659,3.395,17.238z M14.795,21.047c0.422,0,0.762,0.341,0.762,0.762
                            s-0.34,0.762-0.762,0.762h-4.57c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762H14.795z M4.157,8.859
                            c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762h10.639c0.422,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762
                            H4.157z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M15.639,16.111L14.976,18.1c-0.099,0.298,0.185,0.581,0.481,0.481l1.988-0.663L15.639,16.111z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M21.555,9.84l-5.017,5.017l2.164,2.163c1.134-1.134,3.339-3.34,5.017-5.017L21.555,9.84z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M25.9,7.655c-0.268-0.27-0.662-0.423-1.08-0.423s-0.813,0.154-1.082,0.424l-1.107,1.107l2.164,2.163
                            c0.605-0.606,1.025-1.025,1.107-1.107C26.496,9.223,26.496,8.252,25.9,7.655z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <path d="M25.902,9.819L25.902,9.819c0.002-0.002,0.002-0.003,0.004-0.004C25.904,9.816,25.904,9.817,25.902,9.819z"/>
                            <path d="M25.906,9.814c0.002-0.002,0.006-0.005,0.006-0.007C25.912,9.809,25.908,9.812,25.906,9.814z"/>
                            <path d="M25.912,9.808C25.918,9.803,25.918,9.803,25.912,9.808L25.912,9.808z"/>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </button>
                  <label v-if="!arrShowAllSignatureQuestion[controlData.queDetails.in_question_master_id]" class="labelpalceholder" :style="{ 'font-size': !showSignatureLabel ? '0' : '' }">Sign Here</label>
                  <vue-signature
                    class="signature"
                    width="100%"
                    height="180px"
                    :id="controlData.queDetails.in_question_master_id"
                    :ref="'signaturePad_'+controlData.queDetails.in_question_master_id"
                    :options="{ onBegin, onEnd: () => onEnd('', index, controlData.validationDetailsObj[1]) }"
                    v-if="!arrShowAllSignatureQuestion[controlData.queDetails.in_question_master_id]"
                  ></vue-signature>
                  <label v-if="arrShowAllSignatureQuestion[controlData.queDetails.in_question_master_id]" class="signature imageContainer">
                    <img
                      :src="signatureQuestionsData[controlData.queDetails.in_question_master_id]"
                      alt="..."
                      class="profileImagePreview img-check"
                      width="100%"
                      height="180px"
                    />
                  </label>
                  <transition name="fade">
                    <button
                      type="button"
                      class="btn sub-main delete-signature"
                      :data-id="controlData.queDetails.in_question_master_id"
                      @click="clearSignature($event);"
                      :style="{ 'visibility': previewSurveyData.chkSurveyQuestionDetails[''+controlData.queDetails.in_question_master_id] ? '' : 'hidden' }"
                    >
                      <i class="fa fa-trash delete-img" aria-hidden="true"></i>

                    </button>
                  </transition>
                </div>
                <div>
                  <span
                    v-show="errors.has('signature_'+controlData.queDetails.in_question_master_id)"
                    class="error"
                  >{{ errors.first('signature_'+controlData.queDetails.in_question_master_id) }}</span>
                </div>
              </div>
              <!-- END Signature question type -->
            </div>
          </transition>
        </div>
      </div>
      <div class="preview_btn_sec">
        <div class="center-btn">
          <div class="submit">
            <button class="btn btn-whitelable sub-main" :disabled="submitted">Submit</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import DatePicker from "vue2-datepicker";
import MultiSelect from "vue-multiselect";
import VueSignature from "vue-signature-pad";
import MapboxAutocomplete from "../MapboxAutocomplete.vue";
import ChildBootDatePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
var { queTypeConfig, frontHostName, constantCommonConfig } = require("../../../config/config.js");

// Custom Component - For Time question type - This component is used for bootstrap datepicker
// #INFO: Don't pass config option as inline literal object to :config prop.
// This will cause date picker to freeze
const BootDatePicker = {
  inject: {
    $validator: "$validator"
  },
  props: [
    "model",
    "requiredValidation",
    "componentName",
    "minDate",
    "maxDate",
    "surQuesTypeId",
    "surQuesMasterId",
    "skipLogicData",
    "currentIndex"
  ],
  data() {
    return {};
  },
  components: {
    ChildBootDatePicker
  },
  template:
    '<child-boot-date-picker v-model="modelValue" v-validate="{required: requiredValidation ? true : false}" :name="componentName" placeholder="Select Time" :config="datepickerConfig" data-vv-as="above" v-on="{ input: requiredValidation ? (currentValue) => (this.$parent.checkDateTimePicker(currentValue, surQuesMasterId)) : null }"></child-boot-date-picker>',
  computed: {
    modelValue: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit("update:model", value);
      }
    },
    datepickerConfig() {
      return {
        minDate: this.minDate
          ? this.surQuesTypeId == this.$parent.vueQueTypeConfig.TYPE_12_HOURS
            ? this.moment(this.minDate, this.$parent.timeFormat12).toDate()
            : this.moment(this.minDate, this.$parent.timeFormat24).toDate()
          : false,
        maxDate: this.maxDate
          ? this.surQuesTypeId == this.$parent.vueQueTypeConfig.TYPE_12_HOURS
            ? this.moment(this.maxDate, this.$parent.timeFormat12).toDate()
            : this.moment(this.maxDate, this.$parent.timeFormat24).toDate()
          : false,
        format:
          this.surQuesTypeId == this.$parent.vueQueTypeConfig.TYPE_12_HOURS
            ? this.$parent.timeFormat12
            : this.$parent.timeFormat24,
        useCurrent: false,
        showClear: true,
        showClose: true,
        defaultDate: this.maxDate
          ? this.surQuesTypeId == this.$parent.vueQueTypeConfig.TYPE_12_HOURS
            ? this.moment(this.maxDate, this.$parent.timeFormat12).toDate()
            : this.moment(this.maxDate, this.$parent.timeFormat24).toDate()
          : this.minDate
          ? this.surQuesTypeId == this.$parent.vueQueTypeConfig.TYPE_12_HOURS
            ? this.moment(this.minDate, this.$parent.timeFormat12).toDate()
            : this.moment(this.minDate, this.$parent.timeFormat24).toDate()
          : false,
        widgetPositioning: {
          vertical: "auto",
          horizontal: "left"
        }
      };
    },
  },
};
export default {
  name: "Content",
  metaInfo() {
    return {
      title: this.siteTitle,
    };
  },
  props: ["siteTitle"],
  components: {
    DatePicker,
    MultiSelect,
    VueSignature,
    MapboxAutocomplete,
    BootDatePicker
  },
  computed: {
    ...mapGetters("previewSurvey", [
      "surveyOriginalQuestionDetails",
      "surveyMasterDetails",
      "surveyQuestionDetails",
      "surveyAllFlagDetails",
      "surveyResponseDetails",
      "defautchkMapMulChoice",
      "defautSetTime",
      "surveyResponseDate",
      "surveyResponseDetailIds",
      "oldResponseAnswer",
      "tempPreviouslySelectedRating",
      "allSurveyAnswersDetails",
      "chkOtherMultipleChoice",
      "signatureQuestionsDetails",
      "storeAllPhotoQuestion",
      "showAllSignatureQuestion",
      "showAllPhotoQuestion",
      "allAddressQuestions",
    ])
  },
  data() {
    return {
      surveyQuestionDetailsData: [],
      quesNo: 0,
      previewSurveyData: {
        chkSurveyQuestionDetails: {},
        chkOtherMulChoice: {},
        chkMapMulChoice: {},
        chkSurveyFlagDetals: [],
        chkSuvreyMasterDetails: [],
        surveyResponseDetailId: [],
      },
      lang: {
        days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        months: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        pickers: [
          "next 7 days",
          "next 30 days",
          "previous 7 days",
          "previous 30 days"
        ],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date/Time Range"
        }
      },
      timePickerOptions: {
        start: "00:00:00",
        step: "00:30:00",
        end: "23:30:00"
      },
      timeFormat12: "hh:mm:ss a",
      timeFormat24: "HH:mm:ss",
      signatureId: 0,
      completedQuesForPerc: [],
      address: "",
      vueQueTypeConfig: queTypeConfig,
      backwardQuesNo: [],
      loaded: [],
      questionsToSubmit: [],
      multipleRules : false,
      tempPreviouslySelected: {},
      submitted: false,
      currentCallOptions: {
        durations: {
          alert: 0
        }
      },
      showSignatureLabel: true,
      timePickerObject: {},
      tempTimePickerValue: {},
      surveyResponseDateDetails: [],
      vueCommonConfig: constantCommonConfig,
      emailCollection: [],
      allSurveyAnswerData: [],
      imageArray: {},
      signatureQuestionsData: [],
      arrStoreAllPhotoQuestion: [],
      arrShowAllSignatureQuestion: [],
      arrShowAllPhotoQuestion: {},
      arrAllAddressQuestions: {},
      blankValue: '',
      arrRemainingQuestion: {},
    };
  },
  mounted: async function() {
    console.log("mounteddd");
    // Custom validation for max
    console.log("Editable Data", this.surveyResponseDetails);
    this.previewSurveyData.chkSurveyQuestionDetails = this.surveyResponseDetails;
    console.log("this.previewSurveyData.chkSurveyQuestionDetails", this.previewSurveyData.chkSurveyQuestionDetails);
    this.arrRemainingQuestion = Object.assign([], this.surveyResponseDetails);
    this.surveyResponseDetailId = this.surveyResponseDetailIds;
    this.previewSurveyData.chkMapMulChoice = this.defautchkMapMulChoice;
    this.tempTimePickerValue = this.defautSetTime;
    this.surveyResponseDateDetails = this.surveyResponseDate;
    this.tempPreviouslySelected = this.tempPreviouslySelectedRating;
    this.previewSurveyData.chkOtherMulChoice = this.chkOtherMultipleChoice
    this.allSurveyAnswerData = this.allSurveyAnswersDetails;
    this.signatureQuestionsData = this.signatureQuestionsDetails;
    this.arrStoreAllPhotoQuestion = this.storeAllPhotoQuestion;
    this.arrShowAllSignatureQuestion = this.showAllSignatureQuestion  //true-image, false-signpad
    this.arrShowAllPhotoQuestion = this.showAllPhotoQuestion
    this.arrAllAddressQuestions = this.allAddressQuestions
    setTimeout(() => {
      for (const key in this.arrAllAddressQuestions) {
        if (Object.hasOwnProperty.call(this.arrAllAddressQuestions, key)) {
          const element = this.arrAllAddressQuestions[key];
          if (this.$refs["map_" + key] && this.$refs["map_" + key][0])
          {
            this.$refs['map_'+key][0].update(element);
          }
        }
      }
    }, 100);

    this.$validator.extend("custom_max", {
      getMessage: (field, args) => {
        return (
          "The " + field + " field must not exceed " + args[0] + " characters."
        );
      },
      validate: (value, args) => {
        var length = args[0];
        if (value === undefined || value === null) {
          return false;
        }

        if (String(value).length <= length || length == "") {
          return true;
        } else {
          return false;
        }
      }
    });
    // Custom validation for regex in serial number of text
    this.$validator.extend("custom_regex", {
      getMessage: (field, args) => {
        let msg = args[1].split("Allowed characters: ")[1];
        if (msg.indexOf("1") > -1) {
          msg =
            "1," +
            msg.slice(0, msg.indexOf("1")) +
            msg.slice(msg.indexOf("1") + 2);
        }
        if (msg.indexOf("A") > -1) {
          msg =
            "A," +
            msg.slice(0, msg.indexOf("A")) +
            msg.slice(msg.indexOf("A") + 2);
        }
        msg = msg.replace(/,\s*$/, "");
        msg = msg.replace("A", "A-Z");
        msg = msg.replace("1", "0-9");
        msg = msg.replace(", ", ",space");
        return "Allowed inputs are " + msg + ".";
      },
      validate: (value, args) => {
        var res = value.match(args[0]);
        if (res) return true;
        else return false;
      }
    });
    // Custom validation for min value
    this.$validator.extend("custom_min_value", {
      getMessage: (field, args) => {
        return "The " + field + " field must be " + args[0] + " or more.";
      },
      validate: (value, args) => {
        var min = args[0];
        if (value === undefined || value === null) {
          return false;
        }

        if (Number(value) >= min || min == "") {
          return true;
        } else {
          return false;
        }
      }
    });
    // Custom validation for max value
    this.$validator.extend("custom_max_value", {
      getMessage: (field, args) => {
        return "The " + field + " field must be " + args[0] + " or less.";
      },
      validate: (value, args) => {
        var max = args[0];
        if (value === undefined || value === null) {
          return false;
        }

        if (Number(value) <= max || max == "") {
          return true;
        } else {
          return false;
        }
      }
    });
    this.surveyQuestionDetailsData = this.surveyQuestionDetails;
    this.previewSurveyData.chkSurveyFlagDetals = this.surveyAllFlagDetails;
    this.previewSurveyData.chkSuvreyMasterDetails = this.surveyMasterDetails;
    if(this.surveyMasterDetails.in_question_flow == 0) {
      this.surveyQuestionDetailsData.map((skipVal, skipKey) =>  {
        this.$set(
            this.surveyQuestionDetailsData[skipKey],
            "validationDetailsObj",
            this.surveyQuestionDetailsData[skipKey].queDetails.validationDetailsObj
          );
        this.$set(
          this.surveyQuestionDetailsData,
          skipKey,
          Object.assign({}, this.surveyQuestionDetailsData[skipKey])
        );
      })
    }
    console.log('this.surveyQuestionDetailsData mounted end', this.surveyQuestionDetailsData)
    console.log('this.surveyMasterDetails',this.surveyMasterDetails)

    this.$validator.extend("valid_email", {
      getMessage: (field, args) => {
        return "";
      },
      validate: (value, args) => {
        return true;
      }
    });
    this.$validator.extend("invalid_email", {
      getMessage: (field, args) => {
        return "This email is invalid";
      },
      validate: (value, args) => {
        return false;
      }
    });

    this.$validator.extend("valid_email2", {
      validate: (value, args) => {
        return true;
      }
    });
    this.$validator.extend("invalid_email2", {
      getMessage: (field, args) => {
        return "";
      },
      validate: (value, args) => {
        return false;
      }
    });

  },
  methods: {
    ...mapActions("previewSurvey", ["editResponse"]),
    hispec() {
      // var parts = window.location.href.split(".");
      let whitelabel = this.$session.get("whitelabel");
      var loc =
        frontHostName +
        process.env.CAKE_BASE_PATH +
        whitelabel +
        process.env.CAKE_SURVEY_PATH;
      // var loc = "http://" + location.hostname + process.env.CAKE_SURVEY_PATH;
      window.location.href = loc;
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          var mainArray = this.previewSurveyData.chkSurveyQuestionDetails;
          if(Object.keys(mainArray).length == 0){
            this.$awn.alert("Please answer atleast one question.", this.currentCallOptions);
            return
          }
          this.$wait.start("adding response");
          this.submitted = true;
          this.addResponseInDb();
          return;
        }
        var requiredQues = this.errors.items.some( (val, key) => {
          return val.rule == 'required'
        });
        var reqErrorMsg = '';
        if(requiredQues) {
          reqErrorMsg = "One or more mandatory questions have not been answered!";
        } else {
          var allErrorAscOrder = this.errors.items.sort(function (a, b) {
            return a.id - b.id;
          });
          var field = allErrorAscOrder[0].field.split('_');
          var quesMasterId = field[field.length - 1];
          var quesData = this.surveyOriginalQuestionDetails.find(
            x => x.in_question_master_id == quesMasterId
          );
          reqErrorMsg = "Question " + quesData.in_question_number + " has validation error";
        }
        this.$awn.closeToasts();
        this.$awn.alert(reqErrorMsg, this.currentCallOptions);
      });
    },
    async addResponseInDb() {
      console.log("addResponseInDb");
      var finalArray = {};
      var mainArray = this.previewSurveyData.chkSurveyQuestionDetails; // Original array with question list
      let includeQuestions = [] //final submitable questions after applying skip logic
      this.surveyQuestionDetails.forEach( (v) => {
        includeQuestions.push(v.queDetails.in_question_master_id)
      })

      let remaining = [];
      this.arrRemainingQuestion.forEach( (v, key) => {
        remaining.push(key);
      })

      let intersectionKeys = remaining.filter(x => !Object.keys(mainArray).includes(x.toString()));
      console.log("intersection",intersectionKeys);
      if(intersectionKeys)
      {
        for (var key in intersectionKeys) {
          var inkey = intersectionKeys[key];
          var quesType = this.surveyQuestionDetailsData.find(
            x => x.queDetails.in_question_master_id == inkey
          );
          finalArray[inkey] = {
              type: quesType.queDetails.in_question_type_id,
              answer: "",
              isAddress:
                this.previewSurveyData.chkSurveyFlagDetals["in_address"].indexOf(
                  inkey
                ) != -1
                  ? 1
                  : 0,
              isDate:
                this.previewSurveyData.chkSurveyFlagDetals["in_date"].indexOf(
                  inkey
                ) != -1
                  ? 1
                  : 0,
              dateFormat:
                (this.previewSurveyData.chkSurveyFlagDetals["in_date_format"].hasOwnProperty(
                  inkey
                ))
                  ? this.previewSurveyData.chkSurveyFlagDetals["in_date_format"][inkey]
                  : "",
              isMedia:
                this.previewSurveyData.chkSurveyFlagDetals["in_media"].indexOf(
                  inkey
                ) != -1
                  ? 0
                  : (quesType.queDetails.in_question_type_id == 28) ? 1 : (quesType.queDetails.in_question_type_id == 27) ? 2 : 0,
              isPhoto:
                this.previewSurveyData.chkSurveyFlagDetals["in_photo"].indexOf(
                  inkey
                ) != -1
                  ? 1
                  : 0,
              isAudit:
                this.previewSurveyData.chkSuvreyMasterDetails["in_audit"] == 1 &&
                this.previewSurveyData.chkSurveyFlagDetals["in_audit"].indexOf(
                  inkey
                ) != -1
                  ? 1
                  : 0,
              isEMailSent:
                this.previewSurveyData.chkSurveyFlagDetals[
                  "in_email_sent"
                ].indexOf(inkey) != -1
                  ? 1
                  : 0,
              questionNo: quesType.queDetails.in_question_number,
              in_response_details_id: this.surveyResponseDetailId[inkey],
              old_st_answer: this.oldResponseAnswer[inkey],
              is_signature_edit: this.arrShowAllSignatureQuestion[inkey],
            };
        }
      }

      for (var key in mainArray) {
        var answer = "";

        var quesType = this.surveyQuestionDetailsData.find(
          x => x.queDetails.in_question_master_id == key
        );

        if (mainArray[key]) {
          var mapArray = this.previewSurveyData.chkMapMulChoice; // array with map details like lat, lng
          var otherArray = this.previewSurveyData.chkOtherMulChoice; // array with other answer details
          key = parseInt(key);

          // If answer found in map array and other array also
          if (mapArray.hasOwnProperty(key) && otherArray.hasOwnProperty(key)) {
            answer = mapArray[key].concat(otherArray[key]);
          } else if (mapArray.hasOwnProperty(key)) {
            // If answer found in only map array
            answer =
              typeof mapArray[key] === "object" &&
              mapArray[key].constructor === Object
                ? [mapArray[key]]
                : mapArray[key];
          } else if (otherArray.hasOwnProperty(key)) {
            // If answer found in only other array also
            answer =
              typeof otherArray[key] === "object" &&
              otherArray[key].constructor === Object
                ? [otherArray[key]]
                : otherArray[key];
          } else {

          // This condition is for only time picker question
          // As we have added default time in v-model so we need to remove from array if someone is not changed time.
          // In short Not send unselected time picker value to server side
          if(quesType.queDetails.in_question_type_id == this.vueQueTypeConfig.TYPE_12_HOURS || quesType.queDetails.in_question_type_id == this.vueQueTypeConfig.TYPE_24_HOURS) {
            answer = [
                {
                  formatted_address: this.tempTimePickerValue[key] ? this.tempTimePickerValue[key] : "",
                  lat: mainArray[key].lat ? mainArray[key].lat : null,
                  lng: mainArray[key].lng ? mainArray[key].lng : null,
                  score:
                    typeof mainArray[key] == "object" && mainArray[key].score
                      ? mainArray[key].score
                      : ""
                }
              ];

            if(this.tempTimePickerValue[key] == undefined || this.tempTimePickerValue[key] == null) {
              answer = [
                {
                  formatted_address: "",
                  lat: mainArray[key].lat ? mainArray[key].lat : null,
                  lng: mainArray[key].lng ? mainArray[key].lng : null,
                  score:
                    typeof mainArray[key] == "object" && mainArray[key].score
                      ? mainArray[key].score
                      : ""
                }
              ];
            }
          }else{
              var formattedAddressValue = typeof mainArray[key] == "object" && mainArray[key].value
                      ? mainArray[key].value
                      : mainArray[key].formatted_address
                      ? mainArray[key].formatted_address
                      : mainArray[key];
              if(quesType.queDetails.in_question_type_id == this.vueQueTypeConfig.TYPE_12_HOURS) {
                formattedAddressValue = this.moment(formattedAddressValue, this.timeFormat24).format(this.timeFormat12);
              }
              // If answer found in main array called chkSurveyQuestionDetails
              // mainArray[key].value is for Rating question type
              answer = [
                {
                  formatted_address: formattedAddressValue,
                  lat: mainArray[key].lat ? mainArray[key].lat : null,
                  lng: mainArray[key].lng ? mainArray[key].lng : null,
                  score:
                    typeof mainArray[key] == "object" && mainArray[key].score
                      ? mainArray[key].score
                      : ""
                }
              ];
            }
          }
          if(includeQuestions.indexOf(key) !== -1) {
            finalArray[key] = {
              type: quesType.queDetails.in_question_type_id,
              answer: answer,
              isAddress:
                this.previewSurveyData.chkSurveyFlagDetals["in_address"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              isDate:
                this.previewSurveyData.chkSurveyFlagDetals["in_date"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              dateFormat:
                (this.previewSurveyData.chkSurveyFlagDetals["in_date_format"].hasOwnProperty(
                  key
                ))
                  ? this.previewSurveyData.chkSurveyFlagDetals["in_date_format"][key]
                  : "",
              isPhoto:
                this.previewSurveyData.chkSurveyFlagDetals["in_photo"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              isMedia:
                this.previewSurveyData.chkSurveyFlagDetals["in_media"].indexOf(
                  key
                ) != -1
                  ? 0
                  : (quesType.queDetails.in_question_type_id == 28) ? 1 : (quesType.queDetails.in_question_type_id == 27) ? 2 : 0,
              isAudit:
                this.previewSurveyData.chkSuvreyMasterDetails["in_audit"] == 1 &&
                this.previewSurveyData.chkSurveyFlagDetals["in_audit"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              isEMailSent:
                this.previewSurveyData.chkSurveyFlagDetals[
                  "in_email_sent"
                ].indexOf(key) != -1
                  ? 1
                  : 0,
              questionNo: quesType.queDetails.in_question_number,
              in_response_details_id: this.surveyResponseDetailId[key],
              old_st_answer: this.oldResponseAnswer[key],
              is_signature_edit: this.arrShowAllSignatureQuestion[key],
            };
          }
        }
        else{
          finalArray[key] = {
              type: quesType.queDetails.in_question_type_id,
              answer: answer,
              isAddress:
                this.previewSurveyData.chkSurveyFlagDetals["in_address"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              isDate:
                this.previewSurveyData.chkSurveyFlagDetals["in_date"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              dateFormat:
                (this.previewSurveyData.chkSurveyFlagDetals["in_date_format"].hasOwnProperty(
                  key
                ))
                  ? this.previewSurveyData.chkSurveyFlagDetals["in_date_format"][key]
                  : "",
              isPhoto:
                this.previewSurveyData.chkSurveyFlagDetals["in_photo"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              isMedia:
                this.previewSurveyData.chkSurveyFlagDetals["in_media"].indexOf(
                  key
                ) != -1
                  ? 0
                  : (quesType.queDetails.in_question_type_id == 28) ? 1 : (quesType.queDetails.in_question_type_id == 27) ? 2 : 0,
              isAudit:
                this.previewSurveyData.chkSuvreyMasterDetails["in_audit"] == 1 &&
                this.previewSurveyData.chkSurveyFlagDetals["in_audit"].indexOf(
                  key
                ) != -1
                  ? 1
                  : 0,
              isEMailSent:
                this.previewSurveyData.chkSurveyFlagDetals[
                  "in_email_sent"
                ].indexOf(key) != -1
                  ? 1
                  : 0,
              questionNo: quesType.queDetails.in_question_number,
              in_response_details_id: this.surveyResponseDetailId[key],
              old_st_answer: this.oldResponseAnswer[key],
              is_signature_edit: this.arrShowAllSignatureQuestion[key],
            };
        }
      }
      console.log("finalArray");
      console.log(finalArray);
      // return;
      this.data = this.$session.getAll();
      this.data["in_survey_Id"] = this.$route.params.sid;
      this.data["in_response_id"] = this.$route.params.rid;
      this.data["responseData"] = JSON.stringify(finalArray);
      this.data["imageArray"] = this.imageArray;
      await this.editResponse(this.data).then(value => {
        this.submitted = false;
        this.$wait.end("editing response");
        if(value.status != 200){
          this.$awn.alert("Something might wrong!");
          return
        }
        if(value.data.flag != 1){
          this.$awn.alert(value.data.msg);
          return
        }
        this.$emit("changeToEndScreen");
      });
    },
    checkListOther(surveyQuesId, e) {
      this.previewSurveyData["chkOtherMulChoice"][surveyQuesId] = {
        formatted_address: e.target.value,
        lat: null,
        lng: null,
        score: this.previewSurveyData["chkSurveyQuestionDetails"][surveyQuesId]
          .score
      };
    },
    checkOtherAnswer: function(index, surveyQuesId, isAddress, e) {
      if (e.target) {
        if (e.target.type == "radio") {
          if (e.target.value == "Other") {
            this.$set(
              this.surveyQuestionDetailsData[index]["queDetails"],
              "other",
              e.target.checked
            );
            delete this.previewSurveyData["chkMapMulChoice"][surveyQuesId];
            //this.previewSurveyData["chkMapMulChoice"][surveyQuesId] = {};
          } else {
            this.$set(
              this.surveyQuestionDetailsData[index]["queDetails"],
              "other",
              false
            );
            delete this.previewSurveyData["chkOtherMulChoice"][surveyQuesId];
            // If address field is ON
            if (isAddress) {
              //this.previewSurveyData["chkOtherMulChoice"][surveyQuesId] = {};
              // If checked then create array for map data and append lat, lng and score into that array
              this.previewSurveyData["chkMapMulChoice"][surveyQuesId] = {
                formatted_address: e.target.value,
                lat: e.target.getAttribute("data-lat"),
                lng: e.target.getAttribute("data-lng"),
                score: e.target.getAttribute("data-score")
              };
            } else {
              this.previewSurveyData["chkMapMulChoice"][surveyQuesId] = {
                formatted_address: e.target.value,
                lat: null,
                lng: null,
                score: e.target.getAttribute("data-score")
              };
            }
          }

          this.uncheck(surveyQuesId, e.target.value, true, index)
        } else if (e.target.type == "checkbox") {
          // for checkbox v-model
          if (!this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId])
            this.previewSurveyData["chkSurveyQuestionDetails"][
              surveyQuesId
            ] = [];
          if (e.target.value == "Other") {
            this.$set(
              this.surveyQuestionDetailsData[index]["queDetails"],
              "other",
              e.target.checked
            );
          } else {
            // If address field is ON
            if (isAddress) {
              // If checked then create array for map data and append lat, lng and score into that array
              if (e.target.checked) {
                if (!this.previewSurveyData["chkMapMulChoice"][surveyQuesId])
                  this.previewSurveyData["chkMapMulChoice"][surveyQuesId] = [];
                this.previewSurveyData["chkMapMulChoice"][surveyQuesId].push({
                  formatted_address: e.target.value,
                  lat: e.target.getAttribute("data-lat"),
                  lng: e.target.getAttribute("data-lng"),
                  score: e.target.getAttribute("data-score")
                });
              } else {
                // If unchecked
                this.previewSurveyData["chkMapMulChoice"][
                  surveyQuesId
                ] = this.previewSurveyData["chkMapMulChoice"][
                  surveyQuesId
                ].filter(item => {
                  return item.formatted_address !== e.target.value;
                });
              }
            } else {
              if (e.target.checked) {
                if (!this.previewSurveyData["chkMapMulChoice"][surveyQuesId])
                  this.previewSurveyData["chkMapMulChoice"][surveyQuesId] = [];
                this.previewSurveyData["chkMapMulChoice"][surveyQuesId].push({
                  formatted_address: e.target.value,
                  lat: null,
                  lng: null,
                  score: e.target.getAttribute("data-score")
                });
              } else {
                // If unchecked
                this.previewSurveyData["chkMapMulChoice"][
                  surveyQuesId
                ] = this.previewSurveyData["chkMapMulChoice"][
                  surveyQuesId
                ].filter(item => {
                  return item.formatted_address !== e.target.value;
                });
              }
            }
          }
        } else {
          //for other textbox
          this.previewSurveyData["chkOtherMulChoice"][surveyQuesId] = {
            formatted_address: e.target.value,
            lat: null,
            lng: null,
            score: e.target.getAttribute("data-score")
          };
        }
      }
    },
    emojiSplitJoin(
      emojiText,
      splitBy,
      lat = "",
      lng = "",
      score = "",
      surveyQuesTypeId = ""
    ) {
      if (surveyQuesTypeId == 3) {
        const listOptions = emojiText.split(splitBy);
        const listLatOptions = lat.split(splitBy);
        const listLngOptions = lng.split(splitBy);
        const listScoreOptions = score.split(splitBy);
        var obj = [];
        listOptions.forEach((property, i) => {
          obj.push({
            formatted_address: property,
            lat: listLatOptions[i] ? listLatOptions[i] : 0,
            lng: listLngOptions[i] ? listLngOptions[i] : 0,
            score: listScoreOptions[i] ? listScoreOptions[i] : ""
          });
        });
        return obj;
      } else {
        return emojiText.split(splitBy);
      }
    },
    onImageClicked(event) {
      if (event.srcElement.classList.contains("check")) {
        event.srcElement.classList.remove("check");
      } else {
        event.srcElement.classList.add("check");
      }
    },
    onEmpjiClicked(index, emojiIndex, event) {
      console.log(index);
      console.log(emojiIndex);
      event.target.parentElement.classList.remove("emoji-selected");
      event.target.parentElement.classList.add("emoji-selected");
    },
    addOptions(searchQuery, id, surQuesId) {
      this.previewSurveyData.chkSurveyQuestionDetails["" + surQuesId].push(
        searchQuery
      );
    },
    onBegin(evt) {
      this.showSignatureLabel = false;
      this.signatureId = evt.target.parentElement.id;
    },
    onEnd(skiplogic = [], index = 0, isRequired) {
      var _id = this.signatureId; //evt.target.parentElement.id
      const { isEmpty, data } = this.$refs[
        "signaturePad_" + _id
      ][0].saveSignature();
      if (!isEmpty) {
        this.$set(this.previewSurveyData.chkSurveyQuestionDetails, _id, data);
        let evt = {
          target: {
            value: this.previewSurveyData.chkSurveyQuestionDetails["" + _id]
          }
        };

        if (isRequired) this.checkInput(_id, evt, true);
        if (this.errors.has("signature_" + _id)) {
          this.errors.remove("signature_" + _id);
        }
      }
    },
    clearSignature(evt) {
      var _id = evt.currentTarget.getAttribute("data-id");
      this.$set(this.previewSurveyData.chkSurveyQuestionDetails, _id, "");
      if(this.arrShowAllSignatureQuestion[_id]) //arrShowAllSignatureQuestion[controlData.queDetails.in_question_master_id]
      {
        this.arrShowAllSignatureQuestion[_id] = false;
      }
      else
      {
        this.showSignatureLabel = true;
        this.$refs["signaturePad_" + _id][0].clearSignature();
        let evnt = {
          target: {
            value: ""
          }
        };
        this.checkInput(_id, evnt, true);
      }
    },
    getKeyByValue(object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },
    setVariable(name, key, val){
      this.$set(
            this.surveyQuestionDetailsData[key],
            name,
            val
          );
      this.$set(
        this.surveyQuestionDetailsData,
        key,
        Object.assign({}, this.surveyQuestionDetailsData[key])
      );

    },
    nextQues() {
      console.log("next questionnn");
      this.$validator.validateAll().then(result => {
        if (result) {
          let oldQues = this.quesNo
          if (this.quesNo != this.surveyQuestionDetailsData.length - 1) {
            //submitonly that questions which are passed skip logic
            if(this.questionsToSubmit.indexOf(this.quesNo) === -1){
              this.questionsToSubmit.push(this.quesNo)
            }
            this.questionsToSubmit = this.questionsToSubmit.filter( (val, key) => {
              return ! (val > this.quesNo)
            })
            console.log('this.questionsToSubmit', this.questionsToSubmit)

            this.backwardQuesNo.push(this.quesNo);
              this.setNextQuestion(this.quesNo, true)

            setTimeout(() => {
              // check if end survey is called in skip logic
              if(oldQues == this.quesNo){
                this.validateBeforeSubmit()
                return
              }
              console.log('this.quesNo in nextques', this.quesNo)
            }, timeoutTime);
            // Skip logic END
            // For signature question type - to store sigature data in pad
            if (
              this.surveyQuestionDetailsData[this.quesNo] && this.surveyQuestionDetailsData[this.quesNo].queDetails &&
              this.surveyQuestionDetailsData[this.quesNo].queDetails
                .in_question_type_id == this.vueQueTypeConfig.TYPE_SIGNATURE
            ) {
              const _id = this.surveyQuestionDetailsData[this.quesNo].queDetails
                .in_question_master_id;
              const value = this.previewSurveyData.chkSurveyQuestionDetails[
                _id
              ];
              console.log(_id);
              console.log(this.$refs["signaturePad_" + _id]);
              setTimeout(() => {
                this.$refs["signaturePad_" + _id][0].clearSignature();
                this.$refs["signaturePad_" + _id][0].fromDataURL(value);
              }, 100);
            } else if (
              // For text and list question type
              this.surveyQuestionDetailsData[this.quesNo] && this.surveyQuestionDetailsData[this.quesNo].queDetails &&
              (this.surveyQuestionDetailsData[this.quesNo].queDetails
                .in_question_type_id == this.vueQueTypeConfig.TYPE_INPUT ||
                this.surveyQuestionDetailsData[this.quesNo].queDetails
                  .in_question_type_id ==
                  this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT ||
                this.surveyQuestionDetailsData[this.quesNo].queDetails
                  .in_question_type_id == this.vueQueTypeConfig.TYPE_LIST) &&
              this.surveyQuestionDetailsData[this.quesNo].queDetails
                .validationDetailsObj[49]
            ) {
              const _id = this.surveyQuestionDetailsData[this.quesNo].queDetails
                .in_question_master_id;
              console.log(
                this.surveyQuestionDetailsData[this.quesNo].queDetails
                  .in_question_type_id
              );
              console.log(this.previewSurveyData);
              const value =
                this.surveyQuestionDetailsData[this.quesNo].queDetails
                  .in_question_type_id ==
                  this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT ||
                this.surveyQuestionDetailsData[this.quesNo].queDetails
                  .in_question_type_id == this.vueQueTypeConfig.TYPE_LIST
                  ? this.previewSurveyData["chkOtherMulChoice"][_id]
                  : this.previewSurveyData.chkSurveyQuestionDetails[_id];
              console.log(value);
              setTimeout(() => {
                if (this.$refs["map_" + _id] && this.$refs["map_" + _id][0])
                  this.$refs["map_" + _id][0].update(
                    value ? value.formatted_address : ""
                  );
              }, 100);
            }
          }
          return;
        }
      });
    },
    prevQues() {
      console.log(this.$refs);
      if (this.quesNo != 0) {
        this.quesNo = this.backwardQuesNo.pop(); //this.quesNo--;
      }
      if (
        this.surveyQuestionDetailsData[this.quesNo].queDetails
          .in_question_type_id == this.vueQueTypeConfig.TYPE_SIGNATURE
      ) {
        const _id = this.surveyQuestionDetailsData[this.quesNo].queDetails
          .in_question_master_id;
        const value = this.previewSurveyData.chkSurveyQuestionDetails[_id];
        console.log(_id);
        console.log(this.$refs["signaturePad_" + _id]);
        setTimeout(() => {
          this.$refs["signaturePad_" + _id][0].clearSignature();
          this.$refs["signaturePad_" + _id][0].fromDataURL(value);
        }, 100);
      } else if (
        (this.surveyQuestionDetailsData[this.quesNo].queDetails
          .in_question_type_id == this.vueQueTypeConfig.TYPE_INPUT ||
          this.surveyQuestionDetailsData[this.quesNo].queDetails
            .in_question_type_id == this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT ||
          this.surveyQuestionDetailsData[this.quesNo].queDetails
            .in_question_type_id == this.vueQueTypeConfig.TYPE_LIST) &&
        this.surveyQuestionDetailsData[this.quesNo].queDetails
          .validationDetailsObj[49]
      ) {
        const _id = this.surveyQuestionDetailsData[this.quesNo].queDetails
          .in_question_master_id;
        const value =
          this.surveyQuestionDetailsData[this.quesNo].queDetails
            .in_question_type_id == this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT ||
          this.surveyQuestionDetailsData[this.quesNo].queDetails
            .in_question_type_id == this.vueQueTypeConfig.TYPE_LIST
            ? this.previewSurveyData["chkOtherMulChoice"][_id]
            : this.previewSurveyData.chkSurveyQuestionDetails[_id];
        setTimeout(() => {
          if (this.$refs["map_" + _id] && this.$refs["map_" + _id][0])
            this.$refs["map_" + _id][0].update(value.formatted_address);
        }, 0);
      }
    },
    checkCheckbox(surveyQuesId, evt) {
      setTimeout(() => {
        var totalCheckbox =
          evt.target.type == "checkbox"
            ? this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId]
                .length
            : [this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId]]
                .length;
        if (totalCheckbox > 0) {
          this.checkInput(surveyQuesId, evt, true);
        } else {
          this.checkInput(surveyQuesId, evt, false);
        }
      }, 100);
    },
    checkMultipleChoice(
      selectedOption,
      id,
      surveyQuesId,
      index,
      isRequired = false
    ) {
      if (selectedOption.formatted_address == "Other") {
        console.log("selectedOption.formatted_address");
        console.log(selectedOption.formatted_address);
        this.$set(
          this.surveyQuestionDetailsData[index]["queDetails"],
          "other",
          true
        );
        delete this.previewSurveyData["chkMapMulChoice"][surveyQuesId];
      } else {
        this.$set(
          this.surveyQuestionDetailsData[index]["queDetails"],
          "other",
          false
        );
        delete this.previewSurveyData["chkOtherMulChoice"][surveyQuesId];
      }
      selectedOption = [selectedOption];
      let evt = {
        target: {
          value: selectedOption
        }
      };
      if (isRequired && selectedOption.length > 0) {
        this.checkInput(surveyQuesId, evt, true);
      } else {
        this.checkInput(surveyQuesId, evt, false);
      }
    },
    checkDateTimePicker(currentValue, surveyQuesId) {
      let evt = {
        target: {
          value: currentValue != null ? currentValue : ""
        }
      };
      this.checkInput(surveyQuesId, evt, true);
    },
    checkInput(surveyQuesId, evt, flag = true) {
      surveyQuesId = parseInt(surveyQuesId);
      if (evt.target.value != "" && flag) {
        if (this.completedQuesForPerc.indexOf(surveyQuesId) == -1) {
          this.completedQuesForPerc.push(surveyQuesId);
          console.log(this.completedQuesForPerc);
          EventBus.$emit(
            "calculatePercentage",
            this.completedQuesForPerc.length
          );
        }
      } else {
        if (this.completedQuesForPerc.indexOf(surveyQuesId) != -1) {
          this.completedQuesForPerc.splice(
            this.completedQuesForPerc.indexOf(surveyQuesId),
            1
          );
          console.log(this.completedQuesForPerc);
          EventBus.$emit(
            "calculatePercentage",
            this.completedQuesForPerc.length
          );
        }
      }
    },
    setValueinText(questionMasterId, evt){
      this.previewSurveyData.chkSurveyQuestionDetails
      let values = evt.target.firstChild.data
      this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] = values.trim();
    },
    async validateEmail(fieldName, evt) {

      var emailVals = this.errors.items.filter(function(item) {
        return item.field == fieldName && item.rule != 'invalid_email';
      });

      if (evt.target.value != "" && emailVals.length <= 0) {
        const field = this.$validator.fields.find({ name: fieldName });
        field.update({ rules: 'invalid_email2' });

        var url = process.env.API_PATH + '/checkAPIEmailValidationWeb';
        await axios
          .post(
            url,
            {
              email: evt.target.value,
              source: 'Add Response',
            },
            {
              headers: { "Content-Type": "application/json" }
            }
          )
          .then(response => {
            field.update({ rules: 'valid_email2' });
            if(response.data.flag == true && response.data.emailIsvalid == false)
            {
              field.update({ rules: 'invalid_email' });
            }
            else
            {
              field.update({ rules: 'valid_email' });
            }
          })
          .catch(error => console.log(error));
      }

    },
    setModelValueForMultipleAns(surveyQuesId, checkbox, evt){
      if(checkbox || checkbox == "undefined"){
        console.log(evt.target.checked);
        if (evt.target.checked) {
          if (!this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId])
            this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId] = [];
          this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId].push(evt.target.value);
        } else {
          // If unchecked
          this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId] = this.previewSurveyData
          .chkSurveyQuestionDetails[surveyQuesId].filter(item => {
            return item !== evt.target.value;
          });
        }

        Vue.delete(this.previewSurveyData.chkOtherMulChoice, surveyQuesId);
      }else{ //radio button
        this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId] = evt.target.value
      }
    },
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function(
      isRequired,
      addressData,
      placeResultData,
      _id,
      surveyQuesId,
      surQuesTypeId = 0,
      e
    ) {
      console.log([
        isRequired,
        addressData,
        placeResultData,
        _id,
        surveyQuesId,
        surQuesTypeId
      ]);
      let evt = {};
      if (
        surQuesTypeId == this.vueQueTypeConfig.TYPE_LIST ||
        surQuesTypeId == this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT
      ) {
        this.$set(this.previewSurveyData["chkOtherMulChoice"], surveyQuesId, {
          lat: addressData["latitude"],
          lng: addressData["longitude"],
          formatted_address: placeResultData.formatted_address,
          score: this.$refs[_id][0].$el.dataset.score
            ? this.$refs[_id][0].$el.dataset.score
            : this.previewSurveyData["chkSurveyQuestionDetails"][surveyQuesId]
                .score // 1st for multiple choice text and 2nd for list question type
        });
        evt = {
          target: {
            value: this.previewSurveyData["chkOtherMulChoice"][
              "" + surveyQuesId
            ]
          }
        };
      } else {
        this.$set(
          this.previewSurveyData.chkSurveyQuestionDetails,
          surveyQuesId,
          {
            lat: addressData["latitude"],
            lng: addressData["longitude"],
            formatted_address: placeResultData.formatted_address,
            score: ""
          }
        );
        evt = {
          target: {
            value: this.previewSurveyData.chkSurveyQuestionDetails[
              "" + surveyQuesId
            ]
          }
        };
      }
      if (isRequired) this.checkInput(surveyQuesId, evt, true);
      if (this.errors.has(_id)) {
        this.errors.remove(_id);
      }
    },
    onMapInputChange(inputValue, _id, surveyQuesId, surQuesTypeId = 0) {
      if (inputValue.newVal == "") {
        surQuesTypeId == this.vueQueTypeConfig.TYPE_MULTIPLE_TEXT
          ? this.$set(
              this.previewSurveyData["chkOtherMulChoice"],
              surveyQuesId,
              ""
            )
          : this.$set(
              this.previewSurveyData.chkSurveyQuestionDetails,
              surveyQuesId,
              ""
            );
        let evnt = {
          target: {
            value: ""
          }
        };
        this.checkInput(surveyQuesId, evnt, true);
      }
    },
    onStarAndEmojiClick(surveyQuesId, evt) {
      console.log("surveyQuesId");
      console.log(surveyQuesId);
      this.$set(this.previewSurveyData.chkSurveyQuestionDetails, surveyQuesId, {
        score: evt.currentTarget.getAttribute("data-score"),
        value: evt.target.value
      });
      this.uncheck(surveyQuesId, evt.target.value)
    },
    handleError(error) {
      this.$awn.alert(error);
    },
    uncheck(surveyQuesId, value, isMultipleChoice = false, index = 0) {
      if (value === this.tempPreviouslySelected[surveyQuesId]) {
        // For mulitiple choice type questions - Radio button only
        if(isMultipleChoice) {
          // If Other option is selected
          if (value == "Other") {
            this.$set(
              this.surveyQuestionDetailsData[index]["queDetails"],
              "other",
              false
            );
            Vue.delete(this.previewSurveyData.chkOtherMulChoice, surveyQuesId);
          }

          Vue.delete(this.previewSurveyData.chkMapMulChoice, surveyQuesId);
          Vue.delete(this.previewSurveyData.chkSurveyQuestionDetails, surveyQuesId);
        } else {
          Vue.delete(this.previewSurveyData.chkSurveyQuestionDetails, surveyQuesId);
        }

        Vue.delete(this.tempPreviouslySelected, surveyQuesId);
        let evnt = {
          target: {
            value: ""
          }
        };
        this.checkInput(surveyQuesId, evnt, true);
      } else {
        console.log("else mainnn");
        this.tempPreviouslySelected[surveyQuesId] = value;
      }
    },
    setTimePickerValue(quesFlow, surQuesTypeId, surveyQuesId, skipLogic, index) {
      // This dialog is used to fill vuetify dialog if v-model is not blank
      this.$refs["dialog_" + surveyQuesId][0].save(this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId]);

      // Convert time format from 12 hour into 24 hour becuase vuetify time picker accept only 24 hour format
      var tpValue = '';
      if(surQuesTypeId == this.vueQueTypeConfig.TYPE_12_HOURS) {
        tpValue = this.moment(this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId], this.timeFormat24).format(this.timeFormat12);
      } else {
        tpValue = this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId];
      }
      // console.log(tpValue);
      this.$set(this.tempTimePickerValue, surveyQuesId, tpValue);

      // Remove validation error if it is stuck in dom
      if (this.errors.has('timepicker_' + surveyQuesId)) {
        this.errors.remove('timepicker_' + surveyQuesId);
      }
    },
    unsetTimePickerValue(surveyQuesId) {
      this.timePickerObject[surveyQuesId] = false;
    },
    clearTimepickerValue(surveyQuesId, requiredValidation, skipLogic, index) {
      // If required then calucalte completed percentage
      if(requiredValidation) {
        this.checkDateTimePicker(null, surveyQuesId);
      }

      // Set model value as Null
      this.previewSurveyData.chkSurveyQuestionDetails[surveyQuesId] = null;
    },
    uploadPhoto(questionMasterId,event) {
      this.imageArray[questionMasterId] = event.target.files[0];
      this.$set(this.arrShowAllPhotoQuestion, questionMasterId, true);
      this.$forceUpdate();
      const file = event.target.files[0];
      var url = URL.createObjectURL(file);

      this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] = url
    },
    removeOldPhoto(questionMasterId,oldPhotoValue,event)
    {
      this.$set(this.arrShowAllPhotoQuestion, questionMasterId, false);
      this.$forceUpdate();
      var newUplodedPhoto = this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId]
      if(newUplodedPhoto.includes("blob"))
      {
        this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] = this.arrStoreAllPhotoQuestion[questionMasterId]; //oldimage
      }
      else
      {
        this.previewSurveyData.chkSurveyQuestionDetails[questionMasterId] = newUplodedPhoto; //newimage
      }
    },
    async toDataURL(url) {
      return new Promise((resolve) => {
          var xhr = new XMLHttpRequest();
          xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
              resolve(reader.result);
            }
            reader.readAsDataURL(xhr.response);
          };
          xhr.open('GET', url);
          xhr.responseType = 'blob';
          xhr.send();
      });
    }
  }
};
</script>
<style lang="scss">
@import "vue-multiselect/dist/vue-multiselect.min.css";
</style>



// WEBPACK FOOTER //
// src/components/EditResponse/Content.vue